import ActionsForm from '@/shared/mixins/actionsForm'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import { loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  props: ['dataFilter'],
  name: 'Tableenterprise',
  mixins: [ActionsForm],
  data () {
    return {
      columns: ['EMPREENDIMENTO', 'ENDERECO', 'CIDADE', 'STATUS', 'TAMANHO'],
      tableData: [],
      dataEnum: [],
      filterOn: false
    }
  },
  watch: {
    dataFilter (newvalue, oldvalue) {
      let filterOn = false
      Object.keys(newvalue).forEach((Element) => {
        if (this.dataFilter[Element] !== null) filterOn = true
      })
      if (filterOn) {
        this.getFilter()
      } else {
        this.onLoad()
      }
      this.filterOn = filterOn
    }
  },
  mounted () {
    this.getAllStatus()
  },
  methods: {
    onLoad () {
      if (localStoreHelper.gestao.empreendimento() != null) {
        this.filterOn = true
      }
      if (this.filterOn === false) {
        loading.push()
        EnterpriseRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(Response => {
            this.tableData = Response.data.data
            this.$refs.tableGrid.LoadAllByData(Response)
            loading.pop()
          })
          .catch(Error => loading.pop())
      } else {
        this.getFilter()
      }
    },
    getFilter () {
      loading.push()
      let filter
      if (localStoreHelper.gestao.empreendimento() == null) {
        filter = this.dataFilter
      } else {
        filter = localStoreHelper.gestao.empreendimento()
      }
      EnterpriseRepository.GetAllPagingSearch(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, filter)
        .then(Response => {
          this.tableData = Response.data.data
          this.$refs.tableGrid.LoadAllByData(Response)
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getAllStatus () {
      loading.push()
      EnterpriseRepository.GetEnum()
        .then(Response => {
          this.dataEnum = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getStatus (status) {
      if (this.dataEnum.length > 0) {
        let statusEnum = this.dataEnum.find((Element) => Element.enum === status)
        if (statusEnum !== null) {
          return statusEnum.descricao
        } else {
          return 'N/D'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/enterprisetable/tableenterprise.js